export const LOCAL_STORAGE_KEY_VIEWED_STORIES = 'viewed-stories';
